import { Tooltip } from '@odo/shared-ui';
import type { CommunicationPatientRef } from '../../../../services/communications';
import { PatientChip } from './PatientChip';

const MAX_PILLS_SHOWN = 2;

function OverflowPill({ names }: { names: string[] }) {
    if (names.length === 0) return null;
    return (
        <Tooltip content={names.join(', ')}>
            <span className="inline-flex items-center rounded-full bg-gray-50 border border-gray-200 text-gray-500 font-semibold text-[11px] h-6 px-2 whitespace-nowrap shrink-0">
                +{names.length}
            </span>
        </Tooltip>
    );
}

interface PatientPillsCappedProps {
    patients: CommunicationPatientRef[];
}

// Same capped-2 + overflow-tooltip treatment as CategoryPillsCapped, applied
// to linked patients instead of categories.
export function PatientPillsCapped({ patients }: PatientPillsCappedProps) {
    if (patients.length === 0) return null;
    const shown = patients.slice(0, MAX_PILLS_SHOWN);
    const overflow = patients.slice(MAX_PILLS_SHOWN);
    return (
        <div className="flex items-center gap-1 min-w-0">
            {shown.map((p) => (
                <PatientChip key={p.id} name={p.name} />
            ))}
            <OverflowPill names={overflow.map((p) => p.name)} />
        </div>
    );
}
